module.exports = __webpack_public_path__ + "static/media/YM44_6.427e95ed.jpg";